import Service, { service } from '@ember/service';
import type MetricsService from 'garaje/services/metrics';
import { APP } from 'garaje/utils/enums';

/**
 * A facade for `metrics` so that we can log to both segment and datadog
 */
export default class RoombaMetricsService extends Service {
  @service declare metrics: MetricsService;

  trackEvent(event: string, properties: AnalyticsTraits = {}, options: EventOptions = {}): void {
    const propertiesWithSharedContext = <AnalyticsTraits>{
      product: APP.ROOMS,
      ...this.metrics.getStateEventProperties(),
      ...properties,
    };
    this.metrics.trackEvent(event, propertiesWithSharedContext, options);
    this.metrics.logMonitorEvent(event, propertiesWithSharedContext);
  }
}
